<template>
  <div class="line-axis-options">
    <template v-if="!main.activeOption.category">
      <el-form-item label="标签显示" for="line-x-label-mode">
        <el-select id="line-x-label-mode" :value="settings.lineXLabelMode" :disabled="main.activeLayoutLocked" aria-label="折线图X轴标签显示" @input="set('lineXLabelMode', $event)">
          <el-option label="自动避让" value="auto" /><el-option label="逐项显示" value="all" /><el-option label="自定义间隔" value="interval" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="settings.lineXLabelMode === 'interval'" label="间隔数量">
        <el-input-number :value="settings.lineXLabelInterval" :disabled="main.activeLayoutLocked" :min="1" :max="1000" :precision="0" controls-position="right" label="折线图X轴间隔数量" @input="set('lineXLabelInterval', $event)" />
      </el-form-item>
      <el-form-item label="日期格式" for="line-x-label-format">
        <el-select id="line-x-label-format" :value="settings.lineXLabelFormat" :disabled="main.activeLayoutLocked" aria-label="折线图X轴日期格式" @input="set('lineXLabelFormat', $event)">
          <el-option label="原始内容" value="original" /><el-option label="月/日（10/23）" value="monthDay" /><el-option label="月-日（10-23）" value="monthDash" /><el-option label="时:分（08:00）" value="hourMinute" />
        </el-select>
      </el-form-item>
    </template>
    <el-form-item label="文字角度">
      <el-input-number :value="settings.lineXLabelRotate" :disabled="main.activeLayoutLocked" :min="-90" :max="90" :step="5" controls-position="right" label="折线图X轴文字角度" @input="set('lineXLabelRotate', $event)" />
    </el-form-item>
    <p>七日趋势可选“逐项显示＋月/日＋首尾留白”，角度设为 0°。日期格式只改变文字，普通分类保持原样；标签密集时可选自动避让。</p>
  </div>
</template>
<script>
import { lineXAxisSettings } from '@/runtime/line-xaxis'
export default {
  inject: ['main'],
  computed: { settings () { return lineXAxisSettings(this.main.activeOption) } },
  methods: { set (key, value) { if (!this.main.activeLayoutLocked) this.$set(this.main.activeOption, key, value) } }
}
</script>
<style scoped>
.line-axis-options .el-select, .line-axis-options .el-input-number { width: 100%; }
.line-axis-options p { margin: 4px 0 12px; color: var(--editor-muted, #a4b6c5); font-size: 11px; line-height: 1.65; overflow-wrap: anywhere; }
</style>
